<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="relative inline-block" id="region-menu-container">
    <button
      @click="() => (opened = true)"
      type="button"
      class="inline-flex justify-between bg-white w-[220px] pl-4 pr-3 mr-2 py-2 rounded-md border border-gray-300 shadow-sm text-sm font-bold text-gray-700 hover:bg-gray-50 focus:outline-none"
      id="options-menu"
      aria-expanded="true"
      aria-haspopup="true"
    >
      {{ selectedRegion.label }}
      <!-- Heroicon name: solid/chevron-down -->
      <svg
        class="h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <div
      v-click-outside="handleClose"
      v-if="opened"
      class="origin-top-right absolute z-10 left-0 mt-2 w-[220px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <div class="py-1" role="none">
        <div v-for="(region, index) in regions" :key="index">
          <a
            href="#"
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            role="menuitem"
            @click="changeRegion(region.value)"
            >{{ region.label }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegionSelector",
  props: {
    modelValue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      opened: false,
      regions: [
        { label: "Australia 🇦🇺", value: "au" },
        { label: "New Zealand 🇳🇿", value: "nz" },
        { label: "United Kingdom 🇬🇧", value: "uk" }
      ]
    };
  },
  computed: {
    selectedRegion() {
      return this.regions.find((obj) => {
        return obj.value === this.modelValue;
      });
    }
  },
  emits: ["update:modelValue"],
  directives: {
    "click-outside": {
      mounted(el, { value: closeFunction }) {
        window.addEventListener("click", closeFunction);
      },
      unmounted(el, { value: closeFunction }) {
        window.removeEventListener("click", closeFunction);
      }
    }
  },
  methods: {
    handleClose() {
      if (this.opened) {
        if (
          !document
            .getElementById("region-menu-container")
            .contains(window.event.target)
        ) {
          this.opened = false;
        }
      } else {
        this.opened = true;
      }
    },
    changeRegion(region) {
      this.$emit("update:modelValue", region); // previous: `this.$emit('input', title)`
    }
  }
};
</script>
